import React from 'react';
import { Link } from 'gatsby';
import { getPostPath } from '../../../model/post';
import { Section } from '../index';
import parse from 'html-react-parser';
import { useWipAuthors } from '../../../hooks/use-wip-authors';
import { getPostAuthors } from '../../../model/author';

const DocumentarySummary = ({ issue, lazyLoad }) => {
  const { name: articleType, posts } = issue;

  const {
    title,
    slug,
    featuredImage,
    categories: { nodes: categories },
    tghpwipDocumentarySubtitle: documentarySubtitle,
    tghpwipDocumentaryAuthor: authorIds,
  } = posts.nodes[0];

  const allAuthors = useWipAuthors();
  const postAuthors = getPostAuthors(authorIds, allAuthors);

  const categorySlug = categories[0]?.slug;
  const postImage = featuredImage?.node;

  const linkProps = {
    to: getPostPath(slug),
  };

  return (
    <Link {...linkProps}>
      <Section
        type="documentary"
        issue={issue}
        color={categorySlug ? categorySlug : `black`}
        expandButtonLocation={false}
        className="summary-issue-grid"
      >
        <div className="documentary-issue-grid__image summary-issue-grid__image">
          {postImage && (
            <>
              <img
                src={postImage.publicUrl}
                srcSet={postImage.srcSet}
                alt={postImage.altText}
                sizes="100vw"
                loading={lazyLoad ? 'lazy' : 'eager'}
              />
            </>
          )}
        </div>
        <div className="summary-issue-grid__body">
          <div className="summary-issue-grid__body-inner">
            <div className="documentary-issue-grid__body-section summary-issue-grid__body-section">
              <div className="summary-issue-grid__body-section-title">{title}</div>
              <div className="summary-issue-grid__body-section-subtitle">
                Directed by{' '}
                {postAuthors
                  .map((author, idx) => (
                    <strong key={idx}>{author.name}</strong>
                  ))
                  .reduce((prev, curr) => [prev, ' & ', curr])
                }
              </div>
              <hr />
              <div className="documentary-issue-grid__body-description">{documentarySubtitle}</div>
              <div className="documentary-issue-grid__watch-button">
                Watch now {parse(`&#8594`)}
              </div>
            </div>
          </div>
        </div>
        <div className="summary-issue-grid__footer">
          <span>Film</span>
        </div>
      </Section>
    </Link>
  );
};

export default DocumentarySummary;

/*

        <div className="documentary-issue-grid__content">
          <div className="documentary-issue-grid__head">
            <div className="documentary-issue-grid__head-title">
            </div>
            <div className="documentary-issue-grid__head-episode-title">
              <span>
                {episodeTitle &&
                  `${
                    documentaryEpisodes.length > 1 ? `Ep. ${currentEpisode + 1} - ` : ''
                  }${episodeTitle}`}
              </span>
              <span>{episodeTitle}</span>
            </div>
            <div {...linkWithEpisodeProps} className="documentary-issue-grid__head-button">
              <span>Watch now</span>
              <span>Watch →</span>
            </div>
          </div>
          <div className="documentary-issue-grid__episodes documentary-episodes">
            {documentaryEpisodes.length > 1 && (
              <Episodes
                episodes={documentaryEpisodes}
                onChangeEpisode={onChangeEpisode}
                currentEpisode={currentEpisode}
              />
            )}
          </div>
        </div>
 */
